/**
 * Protege rotas que só podem ser acessadas por admin sem instituição selecionada
 * (ex.: Dash Gerencial, Splits Globais, Checklist). Redireciona para /drftadmin
 * se não autenticado, para /home se não for admin ou se admin tiver instituição
 * selecionada.
 */

import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useInstitution } from '@/contexts/InstitutionContext'
import styles from './ProtectedRoute.module.css'

interface AdminOnlyRouteProps {
  children: React.ReactNode
}

export function AdminOnlyRoute({ children }: AdminOnlyRouteProps) {
  const { token, guard, isLoading } = useAuth()
  const { institutionId } = useInstitution()

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <div className={styles.spinner} />
        <p>Carregando...</p>
      </div>
    )
  }

  if (!token) {
    return <Navigate to="/drftadmin" replace />
  }

  if (guard !== 'admin') {
    return <Navigate to="/home" replace />
  }

  if (institutionId !== null) {
    return <Navigate to="/home" replace />
  }

  return <>{children}</>
}
